var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVotaGiallo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.17,
    height: 86.17,
    viewBox: "0 0 86.17 86.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10124",
    "data-name": "Raggruppa 10124",
    transform: "translate(-107.517 -254.017)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1813",
    "data-name": "Ellisse 1813",
    cx: 43.085,
    cy: 43.085,
    r: 43.085,
    transform: "translate(107.517 254.017)",
    fill: "#ffb81a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10108",
    "data-name": "Raggruppa 10108",
    transform: "translate(0.534 15.734)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1822",
    "data-name": "Ellisse 1822",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(114.192 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1823",
    "data-name": "Ellisse 1823",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(171.637 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1824",
    "data-name": "Ellisse 1824",
    cx: 28.374,
    cy: 29.584,
    rx: 28.374,
    ry: 29.584,
    transform: "translate(122.042 251.783)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16091",
    "data-name": "Tracciato 16091",
    d: "M161.506,283.907a2.323,2.323,0,0,1,2.286-2.358,2.292,2.292,0,1,1-2.286,2.369Z",
    fill: "#2a3a90",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16092",
    "data-name": "Tracciato 16092",
    d: "M134.749,283.917a2.331,2.331,0,0,1,2.293-2.368,2.292,2.292,0,1,1-2.293,2.369Z",
    fill: "#2a3a90",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_983",
    "data-name": "Linea 983",
    x1: 18.802,
    transform: "translate(140.952 296.215)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotaGiallo);
export default __webpack_public_path__ + "static/media/vota-giallo.116d539c63534a37b2327464c07ef893.svg";
export { ForwardRef as ReactComponent };